export default __webpack_public_path__ + "static/media/tickBox.04ad0e6f.svg";